import { ForwardedRef, forwardRef, HTMLAttributes, memo, PropsWithChildren, useCallback, useContext } from 'react';
import cls from 'classnames';

import MenuContext from '@/common/components/MenuList/MenuContext/MenuContext';

import styles from './MenuItem.module.css';

export interface MenuItemProps extends HTMLAttributes<HTMLDivElement> {
  onClick?: () => void;
  disabled?: boolean;
  active?: boolean;
  className?: string;
  light?: boolean;
}

function MenuItem(props: PropsWithChildren<MenuItemProps>, ref: ForwardedRef<HTMLDivElement>) {
  const { onClick, active, disabled, className, light, children, ...rest } = props;

  const context = useContext(MenuContext);

  const handleClick = useCallback(() => {
    if (context?.onClick) {
      context.onClick();
    }

    if (onClick) {
      onClick();
    }
  }, [context, onClick]);

  return (
    <div
      ref={ref}
      className={cls(
        styles.menuItem,
        {
          [styles.menuItemClickable]: Boolean(onClick),
          [styles.menuItemDisabled]: disabled,
          [styles.menuItemActive]: active,
          [styles.menuItemLight]: light,
        },
        className,
      )}
      aria-disabled={disabled || undefined}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </div>
  );
}

export default memo(forwardRef<HTMLDivElement, PropsWithChildren<MenuItemProps>>(MenuItem));
